export default "__VITE_ASSET__Dtdi6aGz__"